<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4">
      <div>
        <h3 class="text-sm font-medium text-gray-900 flex items-center gap-2">
          {{ roleName }}
        </h3>
      </div>
    </td>
    <td class="px-4 py-4 w-0">
      <div
        v-if="customRole && (ownsAccount || $isAdminOrSuperAdmin)"
        class="flex gap-3 justify-end"
      >
        <EditRoleAction
          v-if="$membershipHasPermissionTo('edit roles')"
          :role="role"
          @updated="$emit('change')"
        />
        <DeleteRoleAction
          v-if="$membershipHasPermissionTo('delete roles')"
          :role="role"
          @deleted="$emit('change')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import EditRoleAction from './EditRoleAction.vue';
import DeleteRoleAction from './DeleteRoleAction.vue';

export default {
  components: { EditRoleAction, DeleteRoleAction },
  props: {
    role: {
      type: Object,
      required: true,
    },
    ownsAccount: Boolean,
  },
  computed: {
    roleName() {
      return this.role?.name || 'Unknown role';
    },
    customRole() {
      return this.role?.custom;
    },
  },
};
</script>
